if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        const prev = this.querySelector('.product-media-modal__prev');
        const next = this.querySelector('.product-media-modal__next');
        const content = this.querySelector('.product-media-modal__dialog');
        prev?.addEventListener('click', (e) => { e.stopPropagation(); this.navigate(-1); });
        next?.addEventListener('click', (e) => { e.stopPropagation(); this.navigate(1); });
        prev?.addEventListener('pointerup', (e) => e.stopPropagation());
        next?.addEventListener('pointerup', (e) => e.stopPropagation());
        // Clicking inside the dialog box should not close the modal
        content?.addEventListener('pointerup', (e) => e.stopPropagation());
      }

      connectedCallback() {
        super.connectedCallback();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.bindKeyboard();
        this.bindSwipe();
      }

      hide() {
        super.hide();
        this.unbindKeyboard();
      }

      get slides() {
        return Array.from(this.querySelectorAll('.product-media-modal__slide'));
      }

      get currentIndex() {
        return this.slides.findIndex((s) => s.classList.contains('active'));
      }

      showActiveMedia() {
        const targetId = this.openedBy.getAttribute('data-media-id');
        this.slides.forEach((slide) => slide.classList.remove('active'));

        const innerMedia = this.querySelector(`[data-media-id="${targetId}"]`);
        const activeSlide = innerMedia?.closest('.product-media-modal__slide');
        if (!activeSlide) return;

        activeSlide.classList.add('active');
        this.updateNavButtons();

        const deferred = activeSlide.querySelector('deferred-media, product-model');
        if (deferred?.querySelector('template')?.content?.querySelector('.js-youtube')) {
          deferred.loadContent?.();
        }
      }

      navigate(direction) {
        const slides = this.slides;
        if (!slides.length) return;
        const current = this.currentIndex;
        const next = (current + direction + slides.length) % slides.length;
        slides[current].classList.remove('active');
        slides[next].classList.add('active');
        this.updateNavButtons();
      }

      updateNavButtons() {
        const idx = this.currentIndex;
        const total = this.slides.length;
        const prev = this.querySelector('.product-media-modal__prev');
        const next = this.querySelector('.product-media-modal__next');
        // Always show arrows; disable (not hide) at ends
        if (prev) {
          prev.style.visibility = 'visible';
          prev.disabled = idx <= 0;
        }
        if (next) {
          next.style.visibility = 'visible';
          next.disabled = idx >= total - 1;
        }
      }

      bindKeyboard() {
        this._onKeydown = (e) => {
          if (e.key === 'ArrowLeft') this.navigate(-1);
          if (e.key === 'ArrowRight') this.navigate(1);
        };
        document.addEventListener('keydown', this._onKeydown);
      }

      unbindKeyboard() {
        if (this._onKeydown) document.removeEventListener('keydown', this._onKeydown);
      }

      bindSwipe() {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        let startX = 0;
        this._onTouchStart = (e) => { startX = e.touches[0].clientX; };
        this._onTouchEnd = (e) => {
          const diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 40) this.navigate(diff > 0 ? 1 : -1);
        };
        content.addEventListener('touchstart', this._onTouchStart, { passive: true });
        content.addEventListener('touchend', this._onTouchEnd, { passive: true });
      }
    }
  );
}
